








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class Cutin extends Vue {
  @Prop({ default: 'left' }) direction?: 'left' | 'right' | 'top' | 'bottom';

  created() {
    setTimeout(() => {
      this.$emit('cutinEnd')
    }, 2000)
  }

  get directionClass() {
    return { [`to_${this.direction}`]: true }
  }
}
